/**
 * @public
 */
export enum TeamsTheme {
    HighContrast = "teamsHighContrastTheme",
    Dark = "teamsDarkTheme",
    Default = "teamsTheme",
}
